import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../Auth/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';

const MobileBottomNav = ({ cartCount = 0 }) => {
  const location = useLocation();
  const { user, userType } = useAuth();
  const { t } = useLanguage();
  
  // Don't show bottom nav if user is not logged in
  if (!user) return null;
  
  const isActive = (path) => {
    return location.pathname === path ? 'text-primary' : 'text-secondary';
  };

  // Different navigation options based on user type
  const renderNavItems = () => {
    // Common items for all user types
    const commonItems = (
      <>
        <Link to="/" className="mobile-nav-item">
          <div className={`mobile-nav-icon ${isActive('/')}`}>🏠</div>
          <span className={isActive('/')}>{t('nav.home')}</span>
        </Link>
      </>
    );
    
    if (userType === 'admin') {
      return (
        <>
          {commonItems}
          <Link to="/admin-dashboard" className="mobile-nav-item">
            <div className={`mobile-nav-icon ${isActive('/admin-dashboard')}`}>🏛️</div>
            <span className={isActive('/admin-dashboard')}>Dashboard</span>
          </Link>
          <Link to="/admin/users" className="mobile-nav-item">
            <div className={`mobile-nav-icon ${isActive('/admin/users')}`}>👥</div>
            <span className={isActive('/admin/users')}>Users</span>
          </Link>
          <Link to="/adminupload" className="mobile-nav-item">
            <div className={`mobile-nav-icon ${isActive('/adminupload')}`}>📤</div>
            <span className={isActive('/adminupload')}>Upload</span>
          </Link>
        </>
      );
    }
    
    if (userType === 'delivery') {
      return (
        <>
          {commonItems}
          <Link to="/delivery-dashboard" className="mobile-nav-item">
            <div className={`mobile-nav-icon ${isActive('/delivery-dashboard')}`}>🚚</div>
            <span className={isActive('/delivery-dashboard')}>Deliveries</span>
          </Link>
          <Link to="/orders" className="mobile-nav-item">
            <div className={`mobile-nav-icon ${isActive('/orders')}`}>📦</div>
            <span className={isActive('/orders')}>Orders</span>
          </Link>
        </>
      );
    }
    
    // Default is customer
    return (
      <>
        {commonItems}
        <Link to="/cart" className="mobile-nav-item position-relative">
          <div className={`mobile-nav-icon ${isActive('/cart')}`}>
            🛒
            {cartCount > 0 && (
              <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: '0.7rem', transform: 'translate(-50%, -50%)' }}>
                {cartCount}
              </span>
            )}
          </div>
          <span className={isActive('/cart')}>{t('nav.cart')}</span>
        </Link>
        <Link to="/orders" className="mobile-nav-item">
          <div className={`mobile-nav-icon ${isActive('/orders')}`}>📦</div>
          <span className={isActive('/orders')}>{t('nav.myOrders')}</span>
        </Link>
      </>
    );
  };

  return (
    <div className="mobile-bottom-nav d-md-none">
      <div className="d-flex justify-content-around align-items-center w-100">
        {renderNavItems()}
      </div>
    </div>
  );
};

export default MobileBottomNav;
